<!-- <span>Selected</span> -->
<mat-checkbox *ngIf="enabled" (change)="select($event)" color="accent" labelPosition="before" [checked]="selected">
    Selected</mat-checkbox>
<div class="actions" *ngIf="chart">
    <span class="fill"></span>
    <button mat-icon-button matTooltip="Save as PNG" (click)="saveAs.emit()"
      color="primary">
        <mat-icon>cloud_download</mat-icon>
    </button>
    <button mat-icon-button color="primary" matTooltip="About this chart"
      *ngIf="helper" (click)="helper()">
        <mat-icon>help</mat-icon>
    </button>
</div>
<div class="picker-content" [class.mat-elevation-z3]="selected">
    <ng-content></ng-content>
</div>